<template>
  <div class="w-full max-w-2xl p-4 mx-auto sm:mt-0 sm:px-0">
    <div class="overflow-hidden bg-white rounded-lg shadow-lg shadow-gray-200/80 dark:bg-gray-900 dark:shadow-gray-900/50">
      <slot name="header"></slot>

      <div class="p-4 sm:p-8">
        <!-- Title -->
        <div class="flex justify-between">
          <h3 class="font-medium leading-6 prose text-gray-900 text-md dark:text-white md:text-xl">
            <slot name="title"></slot>
          </h3>
        </div>

        <!-- Content  -->
        <div class="mt-1">
          <div v-if="content.text" class="text-lg leading-relaxed text-gray-900 reading-content dark:text-white" v-html="content.text"></div>
          <ul class="space-y-4 text-gray-900 dark:text-white" v-else-if="content.bullets">
            <template v-for="bullet in content.bullets" :key="bullet">
              <li class="p-2 text-sm leading-relaxed border border-gray-200 rounded-lg group dark:border-gray-600 sm:p-3 sm:text-base">
                {{ bullet }}
                <ShareNetwork class="invisible text-gray-300 group-hover:visible dark:text-gray-600" :network="'twitter'" :url="'https://wisery.io'" :title="bullet" :twitter-user="'WiseryHQ'">
                  <v-icon name="bi-twitter" class="" scale="1" />
                </ShareNetwork>
              </li>
            </template>
          </ul>
        </div>

        <!-- Next, Tweet -->
        <div class="flex items-center mt-8 sm:pb-0" :class="{ 'justify-end': content.bullets, 'justify-between': content.text }">
          <div v-if="content.text">
            <ShareNetwork class="hidden text-gray-300 group-hover:block dark:text-gray-600" :network="'twitter'" :url="'https://wisery.io'" :title="content.text" :twitter-user="'WiseryHQ'">
              <v-icon name="bi-twitter" class="" scale="1" />
            </ShareNetwork>
          </div>
          <div>
            <slot name="next"></slot>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ShareNetwork } from "vue-social-sharing";
export default {
  props: {
    content: Object,
  },
  components: {
    ShareNetwork,
  },
  setup(props) {
    return {
      props,
    };
  },
};
</script>
<style scoped>
.reading-content >>> p {
  margin-bottom: 15px;
}
</style>
